module.exports = __webpack_public_path__ + "img/AI.95117889.svg";